// Toplama akisi kanal tanimlari.
// MarketplaceSource degeri ('website' = kendi sitemiz) → operator kutusu.
export interface PickingChannel {
  source: string; // WmsOrder.MarketplaceSource ile eslesir (kucuk harf)
  label: string;
  color: string;
  logo: string; // public/assets altindaki marka logosu ('' ise ikon fallback kullanilir)
}

// Kendi e-ticaret sitemizi temsil eden kanal kaynagi. Multi-tenant sistemde bu kanalin
// etiketi sabit "Tacreo" degil, oturum acan sirketin adindan (Company) turetilir.
export const WEBSITE_CHANNEL_SOURCE = 'website';

/** EMS Akıllı Depo otomatik aktarımında seçilebilir tüm kanallar. */
export const MARKETPLACE_TRANSFER_CHANNELS: ReadonlyArray<{
  source: string;
  label: string;
}> = [
  { source: 'hepsiburada', label: 'Hepsiburada' },
  { source: 'trendyol', label: 'Trendyol' },
  { source: 'n11', label: 'N11' },
  { source: 'pazarama', label: 'Pazarama' },
  { source: 'pttavm', label: 'PttAVM' },
  { source: WEBSITE_CHANNEL_SOURCE, label: 'Kendi Sitem' },
];

export const DEFAULT_TRANSFER_CHANNELS: string[] = MARKETPLACE_TRANSFER_CHANNELS.map((c) => c.source);

// Toplama ekraninda gosterim sirasi: pazaryerleri + kendi site.
// 'website' etiketi varsayilan olup, calisma zamaninda sirket adiyla degistirilir.
export const PICKING_CHANNELS: PickingChannel[] = [
  { source: 'hepsiburada', label: 'Hepsiburada', color: '#ff6000', logo: '/assets/logo_hb.png' },
  { source: 'trendyol', label: 'Trendyol', color: '#f27a1a', logo: '/assets/Trendyol_mp_logo.png' },
  { source: 'n11', label: 'N11', color: '#7b1fa2', logo: '/assets/logo_n11.svg' },
  { source: 'pazarama', label: 'Pazarama', color: '#e6007e', logo: '/assets/logo_pazarama.svg' },
  { source: 'pttavm', label: 'PttAVM', color: '#e30613', logo: '/assets/logo_ptt.png' },
  // Kendi sitemiz: marka logosu yerine sirkete ozel (notr) magaza ikonu gosterilir.
  { source: WEBSITE_CHANNEL_SOURCE, label: 'Tacreo', color: '#1565c0', logo: '' },
];

export const findPickingChannel = (source?: string): PickingChannel | undefined => {
  if (!source) return undefined;
  const s = source.trim().toLowerCase();
  return PICKING_CHANNELS.find((c) => c.source === s);
};

// Kanal etiketini cozumler. 'website' kanali icin sirket adi (companyName) varsa onu
// kullanir; yoksa kanalin varsayilan etiketine (Tacreo) duser.
export const resolveChannelLabel = (
  channel: Pick<PickingChannel, 'source' | 'label'>,
  companyName?: string | null,
): string => {
  if (channel.source === WEBSITE_CHANNEL_SOURCE) {
    const name = companyName?.trim();
    if (name) return name;
  }
  return channel.label;
};
